import {
  SEND_AUTO_FORM,
  SEND_PROPERTY_FORM,
  GET_POLICIES,
  GET_STATES,
  GET_COUNTIES,
  SET_PERSONAL_POLICIES,
  SET_COMMERCIAL_POLICIES,
  CLEAR_FORM,
  GET_WC_PARTS,
  GET_WC_CAUSES,
  GET_WC_NATURES,
  GET_LOSS_CAUSES,
  SEND_WC_FORM,
  SET_WC_ERROR,
  SET_WC_PDF,
  SET_ATTACHMENT_FAILURES,
  POLICY_SEARCH_RETRIEVE,
  GET_DRIVERS,
  SET_FORM_TYPE,
} from "../actions/forms";

const initialState = {
  autoForm: "",
  propertyForm: "",
  vehicleForm: {},
  glForm: {},
  policies: [],
  formType: null,
  states: [],
  counties: [],
  autoPolicies: [],
  wcPolicies: [],
  homePolicies: [],
  propertyPolicies: [],
  liabilityPolicies: [],
  vehiclePolicies: [],
  clearForm: { auto: false, property: false },
  wcParts: [],
  wcCauses: [],
  wcNatures: [],
  lossCauses: [],
  wcForm: "",
  wcError: false,
  wcPdf: "",
  attachmentFailures: [],
  policyRetrievalData: null,
  drivers: null,
};

export const formsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEND_AUTO_FORM:
      return { ...state, autoForm: action.referenceNumber };
    case SEND_PROPERTY_FORM:
      return { ...state, propertyForm: action.propertyForm };
    case GET_STATES:
      return { ...state, states: action.states };
    case GET_COUNTIES:
      return { ...state, counties: action.counties };
    case GET_POLICIES:
      return { ...state, policies: action.policies };
    case SET_PERSONAL_POLICIES:
      return {
        ...state,
        autoPolicies: action.auto,
        homePolicies: action.home,
      };
    case SET_COMMERCIAL_POLICIES:
      return {
        ...state,
        wcPolicies: action.wc,
        propertyPolicies: action.property,
        liabilityPolicies: action.liability,
        vehiclePolicies: action.vehicle,
      };
    case SET_FORM_TYPE:
      return { ...state, formType: action.formType };
    case CLEAR_FORM:
      return { ...state, clearForm: action.clear };
    case GET_WC_PARTS:
      return { ...state, wcParts: action.parts };
    case GET_WC_CAUSES:
      return { ...state, wcCauses: action.causes };
    case GET_WC_NATURES:
      return { ...state, wcNatures: action.natures };
    case GET_LOSS_CAUSES:
      return { ...state, lossCauses: action.lossCauses };
    case SEND_WC_FORM:
      return { ...state, wcForm: action.referenceNumber };
    case SET_WC_ERROR:
      return { ...state, wcError: action.error };
    case SET_WC_PDF:
      return { ...state, wcPdf: action.pdf };
    case SET_ATTACHMENT_FAILURES:
      return { ...state, attachmentFailures: action.attachmentFailures };
    case POLICY_SEARCH_RETRIEVE:
      return { ...state, policyRetrievalData: action.policyRetrievalData };
    case GET_DRIVERS:
          return { ...state, drivers: action.drivers };
    default:
      return { ...state };
  }
};
